import { Component, EventEmitter, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseCollectionComponent } from '../base-collection.component';
import { SelectableOption } from '../models/selectable-option';

@Component({
  selector: 'boi-checkbox-list',
  templateUrl: './checkbox-list.component.html',
  styleUrls: ['./checkbox-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CheckboxListComponent,
      multi: true
    }
  ]
})
export class CheckboxListComponent extends BaseCollectionComponent implements OnChanges {
  @Output() public readonly selectedOptionChange = new EventEmitter<any>();
  public selectableOptions: Array<SelectableOption>;

  public writeValue(value: any): void {
    super.writeValue(value);

    if (value) {
      this.initializeSelectableOptions();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.availableOptions && !changes.availableOptions.isFirstChange()) {
      this.initializeSelectableOptions();
    }
  }

  public initializeSelectableOptions(): void {
    this.populateSelectableOptionsList();

    this.selectableOptions.forEach((option) => {
      const selectedItem = this.findOptionByValue(option.Code);
      if (selectedItem !== undefined) {
        option.setSelectedItem(selectedItem);
      }
    });
  }

  private populateSelectableOptionsList(): void {
    this.selectableOptions = this.availableOptions.map((item) => {
      const selectableOption = new SelectableOption();
      selectableOption.Code = item[this.valueField];
      selectableOption.Value = item[this.textField];

      return selectableOption;
    });
  }

  private findOptionByValue(code: any): Object {
    const filteredOptions = this.value ? this.value.filter((item) => item[this.valueField] === code) : [];
    if (filteredOptions.length > 0) {
      return filteredOptions[0];
    }

    return undefined;
  }

  public handleCheckEvent(option: SelectableOption): void {
    if (!option.Selected) {
      this.addNewOptionToValueArray(option);
    } else {
      this.removeOptionFromValueArray(option);
    }

    this.selectedOptionChange.emit(option);
  }

  private addNewOptionToValueArray(option: SelectableOption): void {
    const newItem = new Object();
    newItem[this.valueField] = option.Code;
    newItem[this.textField] = option.Value;
    newItem['Selected'] = true;
    option.setSelectedItem(newItem);
    this.value.push(newItem);
    this.onChangeCallback(this.value);
  }

  private removeOptionFromValueArray(option: SelectableOption): void {
    const index = this.value.indexOf(option.Item);
    if (index > -1) {
      this.value.splice(index, 1);
      option.Item = undefined;
      option.Selected = false;
      this.onChangeCallback(this.value);
    }
  }
}
